import React, { useCallback, useState } from 'react';
import './radioGroupV2.scss';
import { Card } from '../../components/widgets/ReportIssue/Issues/common';

export default function RadioGroup(props) {
  const {
    selectOption,
    items,
    selectedDropdownVal,
    radioGroupWidth = '',
  } = props;
  const [selectedOption, setSelectedOption] = useState(null);

  const onRadioSelect = useCallback(
    (item) => {
      const { value } = item;
      if (item.disabled) return;
      setSelectedOption(value);
      selectOption(value, item);
    },
    [selectOption],
  );

  if (!items) return null;

  return (
    <div
      className='tw-flex tw-p-5 tw-flex-col tw-items-start tw-gap-4'
      style={{ width: radioGroupWidth }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <div
            className='radioLabel tw-flex tw-p-5 tw-gap-5 tw-items-center tw-self-stretch tw-bg-grey-100 tw-rounded-2xl'
            onClick={() => onRadioSelect(item)}
          >
            <div className='col'>
              <div
                style={{
                  color: item?.disabled ? '#9C9C9C' : item.color,
                  fontWeight: item.type,
                }}
                className='tw-text-200 tw-font-medium tw-text-grey-800'
              >
                {item.text}
              </div>
              {item.sub_text && (
                <div
                  style={
                    item?.st_style
                      ? { ...item?.st_style }
                      : { color: item.st_color }
                  }
                >
                  {item.sub_text}
                </div>
              )}
              <span className='radioIcon'></span>
            </div>
            <input
              className='green'
              type='checkbox'
              checked={
                selectedOption
                  ? String(selectedOption) === String(item.value)
                  : selectedDropdownVal
                  ? String(selectedDropdownVal) === String(item.value)
                  : null
              }
              value={item.value}
              disabled={item.disabled}
              name={item.value}
            />
            <label
              htmlFor={item.value}
              key={index}
              className={` tw-flex-1 ${
                item.disabled ? 'pointerDisabled' : 'pointer'
              }`}
            ></label>
          </div>
          {item.card && (
            <div className='pb10'>
              <Card content={item.card} />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
